module.exports = __webpack_public_path__ + "img/更多好物.58656c36.png";